import { Button, useModal } from "@shortsworks/ui";
import { useNavigate } from "react-router-dom";
import { CommonSelectModal } from "@app/components/modals/CommonModal";
import { Children } from "react";
import { PlatformType } from "@app/types/platform";

export const PlatformSelectForm = () => {
  const { showModal } = useModal();
  const navigate = useNavigate();
  const platforms = Object.values(PlatformType);

  const handleSelectPlatform = (platformType: string) => async () => {
    if (platformType === PlatformType.CAFE24) {
      const modal = await showModal(CommonSelectModal, {
        title: "카페24 회원인 경우 앱 설치 링크로 이동합니다.",
      }).promise();
      if (!modal.value) {
        return;
      }
      return location.assign("https://store.cafe24.com/kr/apps/24104");
    }
    return navigate("/signup/step2", { state: { path: "step2", platformType } });
  };

  return (
    <>
      <div className="grid gap-2">
        <h1 className="text-3xl font-bold">호스팅 플랫폼</h1>
        <div>현재 운영 중인 쇼핑몰의 플랫폼을 선택해주세요.</div>
      </div>
      {Children.toArray(
        platforms.map((platform) => {
          return (
            <Button
              variant="secondary"
              onClick={handleSelectPlatform(platform)}
            >
              {platform}
            </Button>
          );
        }),
      )}
    </>
  );
};
